
// some basic api support and typical endpoints shared between multiple projects
// ... put anything project specific in the actual project repo

import { DataState } from "../hooks/useData";
import { newNotification } from "../ui/Notification";

export interface FetchOptions {
	suppressNotification?: boolean,
}

export const api_base = {

    endpoint: window.location.href.toString().split(window.location.host)[0] + window.location.host,

	fetch: async <T>(url: string, options?: any, data?: DataState<any>, fetchOptions?: FetchOptions) => {
		return new Promise<T>((resolve, reject) => {

			if (data) {
				data.setApiStatus({ communicating: true });
			}

			fetch(url, options).then((res) => {
				if (res.ok) {
					res.json().then((obj) => {						
						if (data) {
							data.setApiStatus({ communicating: false });
						}

						if (options && (options.method === "POST" || options.method === "PUT")) {
							if (url.indexOf("search") < 0) {
								if (!fetchOptions || !fetchOptions.suppressNotification) {
									newNotification({
										message: "Saved",
										style: "success",
									});	
								}
							}
						} else if (options && options.method === "DELETE") {
							if (!fetchOptions || !fetchOptions.suppressNotification) {
								newNotification({
									message: "Item has been deleted",
									style: "success",
								});	
							}
						}

						resolve(obj as T);
					}).catch((err) => {

						newNotification({
							title: "Error with api response",
							style: "error",
							message: "Unable to interpret data returned ("+url+"): " + JSON.stringify(err),
						});
	
						reject(err);
					});

				} else {

					if (data) {
						data.setApiStatus({ communicating: false });
					}

					res.json().then((obj) => {
						if (obj.redirect) {
							debugger;
							document.location.href = obj.redirect;

						} else {
							let detail = "";
							if (obj && obj.errors && obj.errors.length > 0) {
								for(let e of obj.errors) {
									detail += " - " + e;
								}
							}
							newNotification({
								title: "Error loading resource",
								style: "error",
								message: detail,
							});
						}	
					}).catch((e) => {
						newNotification({
							title: "Failed to load resource",
							style: "error",
							message: url,
						});
	
					});

					reject();
				}

			});
	
		});
	},

    post: async <T>(path: string, body?: any, data?: DataState<any>, fetchOptions?: FetchOptions) => {
        const url = api_base.endpoint + path;

        return api_base.fetch<T>(
			url, 
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json"
				},
				body: body ? JSON.stringify(body) : "",
        	},
			data,
			fetchOptions,
		);
    },

	upload: async <T>(path: string, formData: FormData, data?: DataState<any>, fetchOptions?: FetchOptions) => {
        const url = api_base.endpoint + path;

        return api_base.fetch<T>(
			url, 
			{
				method: "POST",
				body: formData,
        	}, 
			data,
			fetchOptions,
		);
    },

	put: async <T>(path: string, body?: any, data?: DataState<any>, fetchOptions?: FetchOptions) => {
        const url = api_base.endpoint + path;

        return api_base.fetch<T>(
			url, 
			{
				method: "PUT",
				headers: {
					"Content-Type": "application/json"
				},
				body: body ? JSON.stringify(body) : "",
        	}, 
			data,
			fetchOptions,
		);
    },

    delete: async <T>(
		path: string, props: {
        	id: string,
    	}, 
		data?: DataState<any>,
		fetchOptions?: FetchOptions
	) => {
        const url = api_base.endpoint + path.replace(":id", encodeURIComponent(props.id));

        return api_base.fetch<T>(url, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json"
            },
			data,
			fetchOptions,
        });
    },

    get: async <T>(path: string, params?: any, data?: DataState<any>, fetchOptions?: FetchOptions) => {
        let url = api_base.endpoint + path;

        if (params) {
            url += "?" + new URLSearchParams(params);
        }

        return api_base.fetch<T>(url, undefined, data, fetchOptions);
    },

};


